import React, { FunctionComponent } from "react";
import {
  Box,
  Stack,
  StyleProps,
  Text,
} from "@chakra-ui/react";

import { ISiteDataQueueSummary } from "common/all-sites-data";

import AlarmsIndicator from "components/alarms-indicator";
import LiveDataIndicator from "components/live-data-indicator";


interface IProps extends StyleProps {
  name: string;
  location: string | null;
  online: boolean;
  queue: ISiteDataQueueSummary;
  hasAlarms?: boolean;
  onClick: () => void;
  onClickAlarms: () => void;
}


const SitePreview: FunctionComponent<IProps> = ({
  name,
  location,
  online,
  hasAlarms,
  queue,
  onClick,
  onClickAlarms,
}) => {
  return (
    <Box
      className="honeycomb-cell"
      onClick={ onClick }
    >
      <Stack
        className="honeycomb-cell__title"
        alignItems="center"
        position="relative"
      >
        { hasAlarms && <AlarmsIndicator
          size="lg"
          position="absolute"
          top={-50}
          onClick={onClickAlarms}
        />}
        <Text>
          {`${ name ?? "" } ${ location ?? "" }`}
        </Text>
        {(online && queue?.receiving === false) && <LiveDataIndicator
          position="absolute"
          bottom={-50}
        />}
      </Stack>
    </Box>
  );
};

export default SitePreview;
